export default {
  formWrap: {
    borderBottom: '1px solid #d9d9d9',
    backgroundColor: '#fff',
  },
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/HighchartsCharts/styles/index.js